import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LoaderModule } from 'libs/common/src/loader';
import { BannerButtonGroupComponent } from './banner-button-group.component';
import { BannerButtonComponent } from './banner-button.component';

@NgModule({
  declarations: [BannerButtonComponent, BannerButtonGroupComponent],
  imports: [CommonModule, MatRippleModule, LoaderModule, FontAwesomeModule],
  exports: [BannerButtonComponent, BannerButtonGroupComponent],
})
export class BannerButtonModule {}
